/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NavTabBarComponent } from '@gh/common-internal-shared';
import { getRouteParentTitle, getRouteQueryParams } from '@gh/common-shared';

import { assign } from 'lodash';
import { JobBasicInfo } from '../../resources/job-details-tab';
import { ContactDetailsDialogConfig, contactDetailsDialogRoute, JobDetailsModel } from '@gh/builder-shared';
import { ContactType } from '@gh/builder-shared-data';
import { DialogService } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { TranslationTupleOrId } from '@gh/core-mls';

@Component({
  selector: 'gh-job-details-tab-container',
  template: require('./job-details-tab-container.component.html'),
  providers: [JobDetailsModel],
})
export class JobDetailsTabContainerComponent implements OnInit {
  @ViewChild(NavTabBarComponent, { static: true }) navigation: NavTabBarComponent;
  queryParams: Params;
  get basicInfo(): JobBasicInfo {
    return this.model.basicInfo;
  }

  get parentTitle(): TranslationTupleOrId {
    return getRouteParentTitle(this.route) || 'lbl_jobs';
  }

  constructor(private route: ActivatedRoute,
              private dialogService: DialogService,
              private model: JobDetailsModel) {
  }

  ngOnInit(): void {
    const queryParams = getRouteQueryParams(this.route);
    assign(this, { queryParams });
  }

  openContact(): void {
    this.dialogService.openWithInput(contactDetailsDialogRoute, <ContactDetailsDialogConfig>{
      contactType: ContactType.Customer,
      contactId: this.basicInfo.contactId,
      parentTitle: 'lbl_job',
    }).afterClosed().pipe(
      filter$(Boolean))
      .subscribe((contact: any) => {
        this.basicInfo.contactId = contact.contactId;
        this.basicInfo.contactName = contact.name;
      });
  }
}
